<template>
    <div>
        <Headers :title="title" />
        <!-- <img class="GDTE" src="~statics/mobileShouye/GDTE.png" alt=""> -->
        <iframe class="iframe" :src="this.detailVhall"  style="border:0;" ></iframe>
        <div class="detaileMenu">
            <img class="detaileMenu-icon" src="~statics/mobileShouye/goback.png" alt=""  @click="toGoback">
            <img class="detaileMenu-icon" src="~statics/mobileShouye/chat.png" alt="" @click="toChat">
            <img class="detaileMenu-icon" src="~statics/mobileShouye/cardMenu.png" alt="" @click="goExchageCard">
            <img class="detaileMenu-icon" src="~statics/mobileShouye/more.png" alt="" @click="getMenulist">
        </div>
        <van-action-sheet
        @select="onSelect"
        v-model="menuList"
        :actions="actions"
        cancel-text="取消"
        description="更多操作"
        close-on-click-action
        v-if="language == 'zh'"
        />
        <van-action-sheet
        @select="onSelect"
        v-model="menuList"
        :actions="enactions"
        cancel-text="Cancel"
        description="More operations"
        close-on-click-action
        v-else
        />
        <van-popup v-model="cardDialog">
            <div class="card">
                <div class="card-title">
                    <img class="card-title-img" src="~statics/mobileShouye/tishi.png" alt="">
                    <span class="card-title-tishi">{{$t('card').h1}}</span>
                </div>
                <div class="card-content">
                    {{$t('card').msg}}
                </div>
                <van-checkbox v-model="checked" class="card-check">{{$t('card').noCaution}}</van-checkbox>
                <div class="card-button">
                    <div class="cancel" @click="handleCancel">{{$t('card').btn1}}</div>
                    <div class="confirm" @click="exchangeCard">{{$t('card').btn2}}</div>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="contactDialog">
            <div class="contactCard">
                <div class="contactCard-title">
                    <span class="name">{{$t('card').contact}}</span>
                    <img src="~statics/mobileShouye/close@2x.png" alt="" class="close" @click="handleCloseContactDialog">
                </div>
                <div class="contactCard-content">
                    <div class="wrap">
                        <img class="wrap-img" src="~statics/mobileShouye/user@2x.png" alt="">
                        <span class="wrap-name">{{manager_name || '暂无'}}</span>
                    </div>
                    <div class="wrap">
                        <img class="wrap-img" src="~statics/mobileShouye/phone@2x.png" alt="">
                        <span class="wrap-name">{{manager_phone || '暂无'}}</span>
                    </div>
                    <div class="wrap">
                        <img class="wrap-img" src="~statics/mobileShouye/mail@2x.png" alt="">
                        <span class="wrap-name">{{email || '暂无'}}</span>
                    </div>
                    <div class="wrap">
                        <img class="wrap-img" src="~statics/mobileShouye/link@2x.png" alt="">
                        <span class="wrap-name">{{website || '暂无'}}</span>
                    </div>
                    <div class="wrap">
                        <img class="wrap-img" src="~statics/mobileShouye/location@2x.png" alt="">
                        <span class="wrap-name">{{address || '暂无'}}</span>
                    </div>
                </div>
            </div>
        </van-popup>
        <Chat v-show="chatdialog" @cancel="cancel"/>
    </div>
</template>

<script>
import Headers from "../mobileExhibition/components/Headers";
// import Footers from "./components/Footers";
import { mapState } from "vuex";
import api from "@/api";
import Chat from "@/views/mobileChat";


export default {
    
    data(){
        return{
            chatdialog: false,
            checked: false,
            clickFlag: false,
            companyId: '',
            exhibitionId: '',
            instanceId: '',
            menuList: false,
            actions: [
                { 
                    index: 1,
                    name: '展台简介'
                },
                { 
                    index: 2,
                    name: '视频列表' 
                },
                { 
                    index: 3,
                    name: '产品介绍' 
                },
                { 
                    index: 4,
                    name: '联系方式' 
                },
            ],
            enactions: [
                { 
                    index: 1,
                    name: 'Introduction of the booth'
                },
                { 
                    index: 2,
                    name: 'Video list' 
                },
                { 
                    index: 3,
                    name: 'Product introduction' 
                },
                { 
                    index: 4,
                    name: 'Contact' 
                },
            ],
            manager_name: "", //联系人
            manager_phone: "", //联系人电话
            email: "", //公司邮箱
            phone: "", //企业电话
            website: "", //公司网址
            address: "", //企业地址
            // title: "", //标题
            logo: "", //logo
            cardDialog: false,
            contactDialog: false,
            cardId:'',
            is_exchange: null,
            entitle: null,
            cntitle: null,
            detailVhall: ''
         }
    },
    computed: {
        language(){
            return localStorage.getItem('language') || 'zh'
        },
        title(){
            return  this.language == 'zh' ?  this.cntitle : this.entitle
        },
        ...mapState(["userInfo","language"]),
    },
    created() {
        this.companyId = this.$route.query.company_id;
        this.exhibitionId = this.$route.query.exhibition_id;
        this.instanceId = this.$route.query.instance_id;
        this.getExhibitor()
        this.getIntroData()
    },
    mounted(){
        
    },
    methods: {
        toChat(){
            // this.$router.push({
            //     path: '/chat',
            //     query: {
            //         company_id: this.companyId,
            //         exhibition_id: this.exhibitionId,
            //     }
            // })
            this.chatdialog = true
        },
        toGoback(){
            this.$router.go(-1)
        },
        getMenulist(){
            this.menuList = true
        },
        goExchageCard(){
            if(this.is_exchange == 1){
                this.$notify({ type: 'danger',background: '#3a3c3f', message: '请勿重复交换' });
                return
            }else{
                this.cardDialog = true
            }
        },
        handleCancel(){
            this.cardDialog = false
        },
        getExhibitor() {
            api.getExhibitionDetali({
                id: this.companyId,
                params: {
                    exhibition_id: this.exhibitionId
                }
            }).then((res) => {
                if (res.res == 1) {
                    this.cardId = res.info.cards[0].id;
                    this.is_exchange = res.info.is_switch
                    this.cntitle = res.info.company.name
                    this.entitle = res.info.company.locales.en.name
                    this.logo = (res.info.profile.cn.images[0] && res.info.profile.cn.images[0].url) || '';
                    this.manager_name = res.info.company.manager_name;
                    this.manager_phone = res.info.company.manager_phone;
                    this.email = res.info.company.email;
                    this.phone = res.info.company.phone;
                    this.website = res.info.company.website;
                    this.address = res.info.company.address;
                }
            });
        },
        getIntroData() {
          api.getExhibitionDetali({
            id: this.companyId,
            params: {
              exhibition_id: this.exhibitionId
            }
          }).then((res) => {
              if(res.res == 1){
                  this.detailVhall = res.info.vhall.url
                  console.log(this.detailVhall)
              }
          });
          // return new Promise((resolve, reject) => {
            
          // })
        },
        exchangeCard() {
            if(!this.userInfo.id) {
                this.$notify({ type: 'danger',background: '#3a3c3f', message: '请先登录后交换名片' });
                return
            }else {
                api.exchangeCard({
                    exhibition_id: this.exhibitionId,
                    card_id: this.cardId
                }).then((res) => {
                    console.log(res);
                    if (res.res === 1) {
                        this.$notify({ type: 'success', message: res.mes });
                        this.cardDialog = false
                    } else if (res.errCode == 20001) {
                        // this.$store.commit("setState", {
                        //     showUserModal: true
                        // });
                    }else{
                        this.$notify({ type: 'danger',background: '#3a3c3f', message: res.mes });
                    }
                });
            }
        },
        onSelect(item) {
            this.menuList = false;
            if(item.index == 1){
                this.$router.push({
                    path: '/mobileAboutCompany',
                    query: {
                        company_id: this.companyId,
                        exhibition_id: this.exhibitionId,
                        instance_id: this.instanceId
                    }
                })
            }
            if(item.index == 2){
                this.$router.push({
                    path: '/mobileVideoList',
                    query: {
                        company_id: this.companyId,
                        exhibition_id: this.exhibitionId,
                        instance_id: this.instanceId
                    }
                })
            }
            if(item.index == 3){
                this.$router.push({
                    path: '/mobileAboutProduct',
                    query: {
                        company_id: this.companyId,
                        exhibition_id: this.exhibitionId,
                        instance_id: this.instanceId
                    }
                })
            }
            if(item.index == 4){
                this.contactDialog = true
            }
        },
        handleCloseContactDialog(){
            this.contactDialog = false
        },
        cancel() {
            this.chatdialog = false;
        },
    },
    components: {
        Chat,
        Headers
    },
}
</script>

<style lang="scss" scoped>
/deep/ .van-notice-bar__content{
    line-height: .32rem;
    color: #ffffff;
    opacity: 1;
    font-size: 12px
}
/deep/ .van-notice-bar__left-icon{
    color: #fff;
}
/deep/ .van-notice-bar__right-icon{
    color: #fff;
}
/deep/ .van-nav-bar__title{
    color: #fff;
}
/deep/ .van-hairline--bottom{
    background: #194b96;
}
/deep/ .van-icon-search{
    color: #fff;
}
.detaileMenu{
    position: absolute;
    display: flex;
    flex-direction: column;
    bottom: 2.32rem;
    right: .14rem;
    .detaileMenu-icon{
        width: 1.12rem;
        height: 1.12rem
    }
}
.card{
    width: 6.9rem;
    height: 6.08rem;
    background: #ffffff;
    border-radius: 6px;
    .card-title{
        margin: .6rem 0 .5rem 0;
        display: flex;
        justify-content: center;
        align-items: center;
        .card-title-img{
            width: .36rem;
            height: .36rem;
            margin-right: .18rem;
        }
        .card-title-tishi{
            font-size: 18px;
            line-height: .5rem;
            color: #666;
        }
    }
    .card-content{
        font-size: 16px;
        color: #333;
        line-height: .44rem;
        width: 5.3rem;
        height: 1.76rem;
        margin: 0 auto;
        overflow: auto;
    }
    .card-check{
        margin: .3rem 0 .4rem .8rem;
        line-height: .4rem;
        font-size: 14px;
        color: #666;
    }
    .card-button{
        display: flex;
        align-items: center;
        margin-left: .8rem;
        margin-right: .8rem;
        .cancel{
            width: 2.52rem;
            height: .8rem;
            border: 1px solid #004f9a;
            border-radius: 11px;
            font-size: 14px;
            color: #0d5095;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: .26rem;
        }
        .confirm{
            width: 2.52rem;
            height: .8rem;
            background: #0d5095;
            border-radius: 11px;
            font-size: 14px;
            color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
.contactCard{
    width: 6.9rem;
    height: 5.7rem;
    background: #ffffff;
    border-radius: 6px;
    .contactCard-title{
        width: 100%;
        height: 1.02rem;
        background: #194b96;
        padding: 0 .44rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .name{
            font-size: 16px;
            color: #ffffff;
            line-height: .44rem;
            // margin: .32rem 0 .26rem 0;
        }
        .close{
            width: .4rem;
            height:  .4rem;
        }
    }
    .contactCard-content{
        padding: .66rem .44rem 0 .44rem;
        .wrap{
            height: .36rem;
            display: flex;
            align-items: center;
            margin-bottom: .34rem;
            .wrap-img{
                width: .36rem;
                height: .36rem;
                margin-right: .24rem;
            }
            .wrap-name{
                font-size: 14px;
                color: #333;
                // line-height: .66rem;
            }
        }
    }
}
.GDTE{
    width: 3.56rem;
    height: .4rem;
    margin: .3rem 0 0 .3rem;
    position: absolute;
    z-index: 999;
}
.prevBack{
    position: absolute;
    z-index: 999;
    // background: #ffffff;
    left: 0;
    top: 2.5rem;
}
.iframe{
    width: 100%;
    border: 0px;
    height: 15.6rem;
    position: absolute;
    // top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobilezhanquDetaile/index.vue